// export function mapBotAccessStatus(list = []) {
//   const result = {};

//   list.forEach((item) => {
//     const key = `is${item.name}`;
//     result[key] = item.status;
//   });

//   return result;
// }
export function mapBotAccessStatus(list = []) {
  const result = {};

  list.forEach((item) => {
    const key = toCamelCaseKey(item.category_name, item.name);

    if (key) {
      result[key] = item.status;
    }
  });

  return result;
}
function toCamelCaseKey(category, name) {
  const cleanCategory = category?.trim();
  const cleanName = name?.trim();

  if (!cleanCategory || !cleanName) return null;

  return (
    "is" +
    cleanCategory.charAt(0).toUpperCase() +
    cleanCategory.slice(1) +
    cleanName.charAt(0).toUpperCase() +
    cleanName.slice(1)
  );
}
export const buildWelcomeTemplateBody = (teacherData) => {
  const phone =
    teacherData.contactNumber ||
    teacherData.contact_number ||
    teacherData.mobile ||
    null;

  return {
    data: {
      to: Number(phone),
      name: "sample_thanq_template_school_module_new",
      code: "en",
      components: [],
    },
    phoneNumberId: "482018154987298",
  };
};
export const shouldSendWhatsapp = (state) => {
  return state.student?.botAccess?.isWhatsapp === 1;
};
export const shouldSendEmail = (state) => {
  return state.student?.botAccess?.isEmailSuccessful === 1;
};
export const shouldSendSMS = (state) => {
  return state.student?.botAccess?.isSMS === 1;
};
export const getMobileFromStudent = (data) =>
  data?.contact_number ?? data?.contactNumber ?? data?.mobile ?? null;

export const shouldSendFailedEmail = (state) =>
  state.student?.botAccess?.isEmailFailed === 1;
